import type {
  AdminCreateApiKeyBody,
  AdminDeleteApiKeyBody,
  CreateApiKeyBody,
  CreateApiKeyResponse,
  DeleteApiKeyBody,
} from '@retracedgmbh/modules/authentication/contracts';
import { API_ROOT_URL } from '@/lib/constants/api';
import { apiFetch } from '@/lib/utils/apiFetch';
import type { AdminApiKeyListResponse, ApiKeyListResponse } from './types';

export async function fetchApiKeys(qs: string): Promise<ApiKeyListResponse> {
  return apiFetch<ApiKeyListResponse>(`/api/api-keys?${qs}`, {}, API_ROOT_URL);
}

export async function createApiKey(
  payload: CreateApiKeyBody,
): Promise<{ data: CreateApiKeyResponse }> {
  return apiFetch<{ data: CreateApiKeyResponse }>(
    '/api/api-keys',
    {
      method: 'POST',
      body: JSON.stringify(payload),
    },
    API_ROOT_URL,
  );
}

export async function deleteApiKey(label: string): Promise<void> {
  const body: DeleteApiKeyBody = { label };
  return apiFetch<void>(
    '/api/api-keys',
    {
      method: 'DELETE',
      body: JSON.stringify(body),
    },
    API_ROOT_URL,
  );
}

// ─── Admin ───────────────────────────────────────────────────────────────────
// The same three calls for an operator under `/api/admin/api-keys`, each
// naming the company it is acting on. The customer versions above stay as they
// are — an operator is not the company whose keys these are.

export async function fetchAdminApiKeys(
  qs: string,
): Promise<AdminApiKeyListResponse> {
  return apiFetch<AdminApiKeyListResponse>(
    `/api/admin/api-keys?${qs}`,
    {},
    API_ROOT_URL,
  );
}

export async function createAdminApiKey(
  payload: AdminCreateApiKeyBody,
): Promise<{ data: CreateApiKeyResponse }> {
  return apiFetch<{ data: CreateApiKeyResponse }>(
    '/api/admin/api-keys',
    { method: 'POST', body: JSON.stringify(payload) },
    API_ROOT_URL,
  );
}

export async function deleteAdminApiKey(
  payload: AdminDeleteApiKeyBody,
): Promise<void> {
  return apiFetch<void>(
    '/api/admin/api-keys',
    { method: 'DELETE', body: JSON.stringify(payload) },
    API_ROOT_URL,
  );
}
